'use client'

import React, { useState } from 'react'
import { ChevronUp } from 'lucide-react'
import { cn } from '@/lib/utils'
import apply from '@/localization/apply'
import { normalizeId } from '@/lib/utils/string'
import type { CartContent } from '@/lib/api/shopware/cart/cart.types'
import type { Dictionary } from '@/localization/dictionary'

type BundleChildren = NonNullable<CartContent['lineItems'][0]['children']>

type Props = {
  items: BundleChildren
  dict: Dictionary['shoppingBag']['tableView']
  className?: string
}

export default function BundleContents({ items, dict, className }: Props) {
  const [open, setOpen] = useState(false)

  if (!items.length) {
    return null
  }

  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex items-center gap-2 text-sm font-semibold uppercase text-primary-300"
      >
        <ChevronUp
          className={cn('size-4 transition-transform', !open && 'rotate-180')}
        />
        {open ? dict.closeList : dict.showList}
      </button>

      {open && (
        <div className="mt-3 bg-secondary-50">
          <div className="px-4 py-3 text-sm font-semibold uppercase text-secondary-800">
            {dict.bundleContains}
          </div>
          <ul>
            {items.map((child) => (
              <li
                key={child.id}
                className="flex items-start justify-between gap-4 px-4 py-3"
              >
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-semibold uppercase text-secondary-800">
                    {child.label}
                  </span>
                  <span className="text-2xs text-secondary-300">
                    {apply(dict.itemId, {
                      id: normalizeId(child.payload?.customFields?.sap_id) ?? '',
                    })}
                  </span>
                </div>
                <span className="text-sm font-semibold text-secondary-800">
                  {child.quantity}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
